// extracted by mini-css-extract-plugin
export default {"columnTitle":"fLoyo2VAR3NfrdIaiaTg","placeHolderShimmer":"ohmp4qZZ4vYrn9ZlfjSn"};